<template>
  <div class="Activity_Profile">

    <div style="height: 400px;width: 100%;margin-top:12px;margin-bottom:14px;">
      <div style="width: 49.5%;height: 100%; float: left;background-color: #fff;">
        <div class="right" style="margin-top:10px">
          <el-button @click="querycensus(1)"  class="minbtn" style="width: 60px;height:30px;margin-left:30px" size="mini">近一月</el-button>
          <el-button @click="querycensus(3)"  class="minbtn" style="width: 60px;height:30px;" size="mini">近三月</el-button>
          <el-button @click="querycensus(6)"  class="minbtn" style="width: 60px;height:30px;" size="mini">近半年</el-button>
          <el-button @click="querycensus(12)"  class="minbtn" style="width: 60px;height:30px" size="mini">近一年</el-button>
          

          <el-date-picker @change = 'changefun()' value-format="yyyy-MM-dd"  format="yyyy-MM-dd" style="width: 290px;height: 32px;margin-left:20px"  v-model="value1" type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"></el-date-picker>
          <el-button type="primary" style="margin-left:20px;" @click="czfun()">重置</el-button>

        </div>
        
        <div ref="getallstatisticslistdata"  style="width: 95%;height:340px;margin: auto;margin-top:20px"></div>
      </div>

      <div style="width: 49.5%;height: 100%; float: left;margin-left:1%;">
        <div style="width: 49.5%;height: 100%; float: left;background-color: #fff;">
          <div ref="education" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
        </div>
          
        <div></div>

        <div style="width: 49.5%;height: 100%; float: left;margin-left:1%;background-color: #fff;">
          <div ref="education2" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
        </div>
      </div>
    </div>

    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane label="组织活动" class="Activity_Profile_xx">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="活动主题">
            <el-input v-model="formInline.subject" placeholder="活动主题"></el-input>
          </el-form-item>
          <el-form-item label="活动日期">
            <el-date-picker v-model="formInline.subjectTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="primary" @click="cz1">重置</el-button>
          </el-form-item>
        </el-form>
        <div>
          <span style="float: left;">活动类型：</span>
          <ul>
            <li @click="EventType_fun(0)" :class="numclass1==0?'aabb':''">全部</li>
            <li @click="EventType_fun(1)" :class="numclass1==1?'aabb':''">体验型</li>
            <li @click="EventType_fun(2)" :class="numclass1==2?'aabb':''">治疗性</li>
          </ul>
        </div>
        <div style="margin-top: 10px;">
          <span style="float: left;">活动进度：</span>
          <ul>
            <li @click="EventType_fun2(0)" :class="numclass2==0?'aabbcc':''">全部</li>
            <li @click="EventType_fun2(1)" :class="numclass2==1?'aabbcc':''">报名中</li>
            <li @click="EventType_fun2(2)" :class="numclass2==2?'aabbcc':''">待开始</li>
            <li @click="EventType_fun2(3)" :class="numclass2==3?'aabbcc':''">进行中</li>
            <li @click="EventType_fun2(4)" :class="numclass2==4?'aabbcc':''">已结束</li>
          </ul>
        </div>
        <el-table :data="tableData" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="eventKey" label="活动编号"></el-table-column>
          <el-table-column prop="subject"  label="活动主题"></el-table-column>
          <el-table-column prop="eventTypeStr" label="活动类型"></el-table-column>

          <el-table-column label="活动形式">

            <template slot-scope="scope">
              <!-- <span>{{ scope.row.EventRate1 == 1 ? "连续" : "单次"}}</span> -->
              <span>{{scope.row.eventRateStr}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间"></el-table-column>

          <!-- <el-table-column label="活动进度">
            <template slot-scope="scope">
              <span style="color: #52C41A;" v-if="scope.row.schedule == '进行中'"> {{ scope.row.schedule }}</span>
              <span style="color: #0088FF;" v-if="scope.row.schedule == '报名中'">{{ scope.row.schedule }}</span>
              <span style="color: #333333;" v-if="scope.row.schedule == '已结束'">{{ scope.row.schedule }}</span>
            </template>
          </el-table-column> -->
          
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="w" @click="gourl(scope.row,1)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="自助活动">
        <el-form :inline="true" :model="from" class="demo-form-inline">
          <el-form-item label="活动主题">
            <el-input v-model="from.subject" placeholder="活动主题"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="from.times" value-format="yyyy-MM-dd"  type="date"  placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit2">查询</el-button>
            <el-button type="primary" @click="cz2">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData2" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="eventKey" label="活动编号"></el-table-column>
          <el-table-column prop="subject"  label="活动主题"></el-table-column>
          <el-table-column label="活动形式">
            <template slot-scope="scope">
              <span>{{ scope.row.EventRate1 == 1 ? "连续" : "单次" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column label="活动进度">
            <template slot-scope="scope">
              <span style="color: #52C41A;" v-if="scope.row.isActive == '0'">无效</span>
              <span style="color: #0088FF;" v-if="scope.row.isActive == '1'">生效中</span>
              <span style="color: #333333;" v-if="scope.row.isActive == '2'">已结束</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="w" @click="gourl(scope.row,2)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange2" :current-page.sync="from.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts2">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      numclass1:0,
      numclass2:0,
      formInline: {
        pageSize: 10,
        pageIndex: 1,
        holdType: 1,
        eventType: 0,
        eventStatus: 6,
        subject: '',
        subjectTime: '',
        times: '',
        schedule:'0'
      },
      from: {
        pageSize: 10,
        pageIndex: 1,
        holdType: 2,//举办方式 0代表全部 1线下发布或者立项  2代表自助活动 默认为0；
        eventType: 0,//活动类型 0全部 1全部 2全部 开始查询默认为2
        eventStatus: 6,//1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布
        subject: '',//活动主题
        subjectTime: '',//活动日期
        times: '',//创建时间（查询自助活动用）
      },
      Counts: 0,
      tableData: [],
      Counts2: 0,
      tableData2: [],
      startTime:'',
      endTime:'',
      value1:this.Global.querycensus(6),
      Statisticsdata:[]
    };
  },
  created() {
  
  },
  methods: {
    czfun(){
      this.querycensus(6)
    },
    //根据选项查询 
    querycensus(data){
      const censusDate = this.Global.querycensus(data);
      this.beginTime = censusDate[0];
      this.endTime = censusDate[1];
      this.getallstatisticslist();
    },
    getallstatisticslist(){
      this.$Http_Post("/activitymanagement/getallstatisticslist",{ beginTime: this.beginTime,endTime: this.endTime }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Statisticsdata = res.Data;
          this.getallstatisticslistdata();
          this.education();
          this.education2();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    changefun(){
      this.$Http_Post("/activitymanagement/getallstatisticslist",{ beginTime: this.value1[0],endTime: this.value1[1] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Statisticsdata = res.Data;
          this.getallstatisticslistdata();
          this.education();
          this.education2();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    getallstatisticslistdata(){
      var time = [];
      var endCount = [];
      var inProcessCount = [];
      var notStartCount = [];
      var totalCount = [];
      for(var i = 0;i < this.Statisticsdata.eventNumByTime.length;i++){
        time.push(this.Statisticsdata.eventNumByTime[i].time);
        endCount.push(this.Statisticsdata.eventNumByTime[i].endCount);
        inProcessCount.push(this.Statisticsdata.eventNumByTime[i].inProcessCount);
        notStartCount.push(this.Statisticsdata.eventNumByTime[i].notStartCount);
        totalCount.push(this.Statisticsdata.eventNumByTime[i].totalCount);
      }
      var myChart = this.$echarts.init(this.$refs.getallstatisticslistdata);
      var option={
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '活动数量以及状态统计',
          left: '20px',
          top: '10px',
        },
        color:['#93C22D', '#557CD9', '#E3B540','#44B9AC'],
        legend: {
          right:'50',
          top: '10px',
          data:['总活动数', '进行中', '未开始','已结束']
        },
        xAxis: { type: 'category',data:time},

        yAxis: { splitLine: { show: true, lineStyle: { type: 'dashed' } } },
        series: [
          { 
            name:'总活动数',
            data: totalCount,
            type: 'bar',
            smooth: true,
            barWidth: '15',
          },{
            name:'进行中',
            data: inProcessCount,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
          },{ 
            name:'未开始',
            data:notStartCount,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
          },{ 
            name:'已结束',
            data: endCount,
            type: 'bar',
            smooth: true,
            barWidth: '15',
          }, 
        ]
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    // 参加学历占比
    education(){
      var myChart = this.$echarts.init(this.$refs.education);
      var option = {
        title: {
          text: '参加活动学历占比',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D', '#557CD9', '#E3B540'],
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%','60%'],
            data: [
              { value: this.Statisticsdata.peopleNumByDegree[0].counts, name: this.Statisticsdata.peopleNumByDegree[0].degree},
              { value: this.Statisticsdata.peopleNumByDegree[1].counts, name: this.Statisticsdata.peopleNumByDegree[1].degree},
              { value: this.Statisticsdata.peopleNumByDegree[2].counts, name: this.Statisticsdata.peopleNumByDegree[2].degree},
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    education2(){
      var myChart = this.$echarts.init(this.$refs.education2);
      var option = {
        title: {
          text: '参加活动性别占比',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D', '#557CD9'],
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            data: [
              { value: this.Statisticsdata.peopleNumList[0].manCount, name: '男'},
              { value: this.Statisticsdata.peopleNumList[0].womanCount, name: '女'},
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    onSubmit() {
      this.formInline.pageIndex = 1
      this.loading();
    },
    onSubmit2() {
      this.from.pageIndex = 1
      this.loading2();
    },
    cz1(){
      this.formInline = {
        pageSize: 10,
        pageIndex: 1,
        holdType: 1,
        eventType: 0,
        eventStatus: 6,
        subject: '',
        subjectTime: '',
        times: '',
        schedule:'0'
      }
      this.loading();
      
    },
    cz2(){
      this.from = {
        pageSize: 10,
        pageIndex: 1,
        holdType: 2,//举办方式 0代表全部 1线下发布或者立项  2代表自助活动 默认为0；
        eventType: 0,//活动类型 0全部 1全部 2全部 开始查询默认为2
        eventStatus: 6,//1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布
        subject: '',//活动主题
        subjectTime: '',//活动日期
        times: '',//创建时间（查询自助活动用）
      }
      this.loading2();
    },
    gourl(row, type) {
      if (type == 1) {
        this.$router.push({
          path: '/Activity/Activity_Details',
          query: { id: row.eventKey },
        })
      } else {
        this.$router.push({
          path: '/Activity/Activity_Details_self',
          query: { id: row.eventKey },
        })
      }
    },
    EventType_fun(val) {
      this.numclass1 = val
      this.formInline.eventType = val;
      this.formInline.pageIndex = 1;
      this.loading();


    },
    EventType_fun2(val) {
      this.numclass2 = val
      this.formInline.schedule = val;
      this.formInline.pageIndex = 1;
      this.loading();
    },
    loading2() {
      this.$Http_Post('/activitymanagement/geteventplanlist', { from: this.from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts2 = res.Counts;
          this.tableData2 = res.Data;
        }
      })
    },
    loading() {
      this.$Http_Post("/activitymanagement/geteventplanlist",{ from: this.formInline }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadings = false;
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
        } else {
          this.loadings = false;
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val
      this.loading();
    },
    handleCurrentChange2(val) {
      this.from.pageIndex = val
      this.loading2();
    },
  },
  mounted() {
    this.loading();
    this.loading2();
    this.querycensus(6);
  },
};
</script>
<style>
.Activity_Profile{width: 100%;height: 100%;}
.Activity_Profile .list-cnt{width: 100%;height: 100%;}
.Activity_Profile_xx ul{display: inline-block;}
.Activity_Profile_xx ul li{float: left;margin-left: 14px;padding: 1px 5px;cursor: pointer;}
.minbtn{height: 23px !important;padding: 0px;}
.Activity_Profile .right .el-date-editor .el-range__icon,
.Activity_Profile .right .el-date-editor .el-range-separator,
.Activity_Profile .right .el-date-editor .el-range__close-icon{line-height: 24px;}
.Activity_Profile .aabb{background-color: #409eff ;border-radius: 3px;color: #fff;}
.Activity_Profile .aabbcc{background-color: #409eff ;border-radius: 3px;color: #fff;}
</style>
